module.exports = __webpack_public_path__ + "fonts/Roboto-Black.ttf?56aa07e4f2f764e31cb09d8ad1362808";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Black.ttf
// module id = 312
// module chunks = 0